import React, { useEffect, useRef, useState } from 'react';

const SITE = 'https://theseoconsultant.ai';

export const Header: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navRef = useRef<HTMLElement>(null);

  // Close mobile nav on outside click
  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <header className={`site-header ${open ? 'is-open' : ''}`} ref={navRef}>
      <div className="header-inner">
        <a href={SITE} className="logo">
          The&nbsp;SEO&nbsp;Consultant<span className="dot">.</span><span className="ai">ai</span>
        </a>
        <button
          className="nav-toggle"
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="primary-nav"
          onClick={() => setOpen((v) => !v)}
        >
          <span></span><span></span><span></span>
        </button>
        <nav id="primary-nav" className="site-nav" aria-label="Primary">
          <a href={SITE}>Home</a>
          <span className={`has-dropdown ${dropdownOpen ? 'is-open' : ''}`}>
            <button
              className="dropdown-trigger"
              aria-haspopup="true"
              aria-expanded={dropdownOpen}
              onClick={() => setDropdownOpen((v) => !v)}
            >
              SEO Services
            </button>
            <div className="dropdown-menu" role="menu">
              <a href={`${SITE}/seo-services/`}><strong>View All Services</strong></a>
              <a href={`${SITE}/ai-seo-consultant/`} role="menuitem">AI SEO Consultant</a>
              <a href={`${SITE}/travel-seo-consultant/`} role="menuitem">Travel SEO Consultant</a>
              <a href={`${SITE}/real-estate-seo-consultant/`} role="menuitem">Real Estate SEO Consultant</a>
              <a href={`${SITE}/enterprise-seo-consultant/`} role="menuitem">Enterprise SEO Consultant</a>
              <a href={`${SITE}/b2b-seo-consultant/`} role="menuitem">B2B SEO Consultant</a>
              <a href={`${SITE}/small-business-seo-consultant/`} role="menuitem">Small Business SEO Consultant</a>
            </div>
          </span>
          <a href={`${SITE}/about/`}>About</a>
          <a href={`${SITE}/blog/`}>Blog</a>
          <a href={`${SITE}/ai-seo-tools/`}>AI SEO Tools</a>
          <a href={`${SITE}/contact/`}>Contact</a>
        </nav>
      </div>
    </header>
  );
};
